export interface User {
  email: string;
  username: string;
}

export interface Task {
  id: string;
  label: string;
  weekNum?: number;
}

export interface DaySchedule {
  day: string;
  theme: string;
  color: string;
  lightColor: string;
  tasks: Task[];
}

export interface CalendarEntry {
  date: string; // YYYY-MM-DD
  dayIndex: number; // 0-5 (Mon-Sat)
  completedIds: string[];
  totalTasks: number;
}

export type CalendarHistory = Record<string, CalendarEntry>;

export interface CustomTask {
  id: string;
  label: string;
  category: string;
  priority: 'low' | 'medium' | 'high';
  completed: boolean;
  createdAt: string;
  dueDate?: string;
}

export interface AppSettings {
  householdName: string;
  darkMode: boolean;
  fontSize: 'small' | 'medium' | 'large';
  autoReset: boolean;
  activeDays: boolean[]; // [Mon, Tue, Wed, Thu, Fri, Sat]
}

export const DEFAULT_SETTINGS: AppSettings = {
  householdName: '',
  darkMode: false,
  fontSize: 'medium',
  autoReset: true,
  activeDays: [true, true, true, true, true, true],
};

export type PageId = 'schedule' | 'calendar' | 'tasks' | 'settings' | 'customize';

export interface ConfirmConfig {
  title: string;
  message: string;
  confirmLabel?: string;
  danger?: boolean;
  onConfirm: () => void;
}

export const CATEGORY_COLORS: Record<string, string> = {
  General: '#888',
  Errands: '#3B9FC4',
  Shopping: '#C8903E',
  'Home Repair': '#B84A42',
  Cleaning: '#8B5A9E',
  Outdoor: '#5A9A4A',
  Other: '#999',
};

export const PRIORITY_COLORS: Record<string, string> = {
  low: '#5A9A4A',
  medium: '#C8903E',
  high: '#B84A42',
};
